import React, { useState, useEffect, createContext } from "react";
import { getNormalizedRole } from "../../../utils/roleUtils";
import cookieHelper from "../library/helpers/cookieHelper";

const UserContext = createContext({
  userData: {},
  setUserDataFunc: () => { },
  singleDayAvalArr: [0],
});

export function UserContextProvider({ children }) {
  const [userData, setUserData] = useState({});
  const [singleDayAvalArr, setSingleDayAvalArr] = useState([0]);
  const [count, setCount] = useState(1);
  const [unreadMessageData, setUnreadMessageData] = useState(null);

  const updateUnreadMessageData = (data) => {
    setUnreadMessageData(data);
  };

  const fetchUserData = async () => {
    const res = cookieHelper.getUserDetails();
    // Normalize the role if it exists
    if (res && res.role) {
      res.role = getNormalizedRole(res.role);
    }
    setUserData(res);
  };

  const addToSingleDayAval = () => {
    setSingleDayAvalArr((prvData) => {
      return [...prvData, count];
    });
    setCount(count + 1);
  };

  const removeFromSingleDayAval = (c) => {
    let fileArr = singleDayAvalArr.filter((item) => {
      return item !== c;
    });
    setSingleDayAvalArr(fileArr);
  };

  const removeUserData = () => {
    setUserData({});
  };

  const addUserDataFunc = (data) => {
    if (data && data.role) {
      data.role = getNormalizedRole(data.role);
    }
    setUserData(data);
  };

  useEffect(() => {
    fetchUserData();

    const handleLoggedOut = () => {
      setUserData({});
      setUnreadMessageData(null);
    };

    const handleAuthChanged = () => {
      fetchUserData();
    };

    window.addEventListener('userLoggedOut', handleLoggedOut);
    window.addEventListener('authStateChanged', handleAuthChanged);

    return () => {
      window.removeEventListener('userLoggedOut', handleLoggedOut);
      window.removeEventListener('authStateChanged', handleAuthChanged);
    };
  }, []);

  return (
    <UserContext.Provider
      value={{
        userData,
        addToSingleDayAval,
        removeFromSingleDayAval,
        singleDayAvalArr,
        removeUserData,
        addUserDataFunc,
        unreadMessageData,
        updateUnreadMessageData,
      }}
    >
      {children}
    </UserContext.Provider>
  );
}

export { UserContext };
export default UserContext;
